import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  size?: "sm" | "md" | "lg";
}

export function Section({ children, className, id, size = "lg" }: SectionProps) {
  const paddingClasses = {
    sm: "py-6 md:py-8",
    md: "py-8 md:py-12",
    lg: "py-12 md:py-16 lg:py-24",
  };

  return (
    <section
      id={id}
      className={cn(
        "relative w-full",
        paddingClasses[size],
        className
      )}
    >
      <div className="w-full max-w-[1400px] mx-auto px-6 lg:px-12">
        {children}
      </div>
    </section>
  );
}

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  align?: "left" | "center";
}

export function SectionHeader({ title, subtitle, className, align = "left" }: SectionHeaderProps) {
  return (
    <div className={cn(
      "mb-12 md:mb-16",
      align === "center" && "text-center",
      className
    )}>
      <h2 className="font-serif text-display-sm md:text-display-md text-foreground mb-4">
        {title}
      </h2>
      {subtitle && (
        <p className="text-body-lg text-muted-foreground max-w-prose">
          {subtitle}
        </p>
      )}
    </div>
  );
}
